import Banner from "./Banner";
import Card from "./Card/index";
import Cards from "./Cards";
import ContactInfo from "./ContactInfo";
import DetailHeader from "./DetailHeader";
import Fade from "./Fade";
import Hero from "./Hero";
import Html from "./Html";
import Intro from "./Intro";
import Language from "./Language";
import PageHero from "./PageHero";
import SiteHamburger from "./SiteHamburger";
import SiteHeader from "./SiteHeader";
import SiteMobileMenu from "./SiteMobileMenu";
import Stats from "./Stats";
import Subnav from "./Subnav";
import Youtube from "./Youtube";

export default {
	Banner,
	Card,
	Cards,
	ContactInfo,
	DetailHeader,
	Hero,
	Html,
	Intro,
	Language,
	Fade,
	Subnav,
	SiteHamburger,
	SiteHeader,
	SiteMobileMenu,
	Stats,
	PageHero,
	Youtube,
};
